import {
    RESET_CHECKOUT,
    RESET_DELIVERY,
    SET_CHECKOUT_DELIVERY_DATES,
    SET_CHECKOUT_EXCLUDED_PICKERS,
    SET_CHECKOUT_MESSAGE, SET_CHECKOUT_VALIDATION,
} from 'reducers/actions-types';
import { addPromoCode, submit, validate } from './helpers';
import { TOGGLE_CHECKOUT_ERRORS_VISIBILITY } from '../../actions-types';

/* eslint-disable camelcase */
export default Object.freeze({
    submit,
    addPromoCode,
    setMessage({ additional_info }) {
        return { type: SET_CHECKOUT_MESSAGE, additional_info };
    },

    setExcludedPickers({ excluded_pickers }) {
        return { type: SET_CHECKOUT_EXCLUDED_PICKERS, excluded_pickers };
    },
    validate() {
        return (dispatch, getState) => {
            const validationState = validate(getState().checkout);

            dispatch({ type: SET_CHECKOUT_VALIDATION, validationState });

            return validationState;
        };
    },
    reset() {
        return (dispatch) => {
            dispatch({ type: RESET_CHECKOUT });
            dispatch({ type: RESET_DELIVERY });
        };
    },
    toggleErrorsVisibility({ areErrorsVisible }) {
        return { type: TOGGLE_CHECKOUT_ERRORS_VISIBILITY, areErrorsVisible };
    },

    /**
     * Set delivery time range
     * @param {string | string} delivery_start_date
     * @param {string | null} delivery_end_date
     * @return {{delivery_start_date: *, type: *, delivery_end_date: *}}
     */
    setDates({ delivery_start_date, delivery_end_date }) {
        return { type: SET_CHECKOUT_DELIVERY_DATES, delivery_start_date, delivery_end_date };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/checkout/actions.js